export let startScreen = {
	init: function(data){
		//console.log(data);
		let HTML = "";
		for( let i = 0; i < 30; i++){
			let d = data[i];
			let img = "";
			if( d.image ){
				img = `<picture>
							<source media="(min-width: 864px)" srcset="${d.image.url}?fm=webp&w=560" width="280" height="400" decoding="async">
							<img src="${d.image.url}?fm=webp&&w=" width="128" height="182" decoding="async" alt="${d.name}">
						</picture>`;
			}
			HTML += `<li class="c">
						<div class="inr">
							<figure>
								${img}
							</figure>
							<p><img src="/assets/images/common/logo_asl.svg" alt="ASL" width="67" height="19"></p>
						</div>
					</li>`;
		}
		document.querySelector(".c-start_cards ul").innerHTML = HTML;
		startScreen.resize();
		
		setTimeout(function(){
			startScreen.resize();
			document.querySelector(".cover").classList.add("disable");
		}, 200);
	},
	resize: function(){
		let $wrap = document.querySelector(".c-start_cards");
		let $cards = document.querySelectorAll(".c-start_cards ul li");
		let $startBlock = document.querySelector(".c-start");
	
		let wrapW = $wrap.clientWidth;
		let wrapH = $wrap.clientHeight;
		let centerX = Math.floor(wrapW / 2);
		let centerY = Math.floor(wrapH / 2);
	
		let startBlockW = $startBlock.clientWidth;
		let startBlockH = $startBlock.clientHeight;
	
		let cardW = $cards[0].clientWidth;
		let cardH = $cards[0].clientHeight;
		let cardM = getPx( getComputedStyle( document.querySelector("#b-start") ).getPropertyValue('--srart-card-margin') );
		
		
		if(window.innerWidth <= 768){
			// SP: 5列, 上2行 + 下3行
			let cols = 5;
			let topRows = 3;
			let bottomRows = 3;
			// グリッド全体の幅を算出（5枚分 + 4gap分）
			let gridW = cols * cardW + (cols - 1) * cardM;
			let gridStartX = centerX - gridW / 2;
	
			// .c-startエリアの上端・下端を取得
			let startRect = $startBlock.getBoundingClientRect();
			let wrapRect = $wrap.getBoundingClientRect();
			let startTop = startRect.top - wrapRect.top;
			let startBottom = startTop + startBlockH;
	
			let count = 0;
	
			// 上2行: .c-startの上に配置（下詰め）
			for(let y = 0; y < topRows; y++){
				for(let x = 0; x < cols; x++){
					let $card = $cards[count];
					if($card){
						let posX = gridStartX + x * (cardW + cardM);
						// 下詰め: startTopから上に向かって配置
						let posY = startTop - cardM - (topRows - y) * (cardH + cardM) + cardM;
						$card.style.transform = `translate3d(${posX}px, ${posY}px, 0)`;
					}
					count++;
				}
			}
	
			// 下3行: .c-startの下に配置（上詰め）
			for(let y = 0; y < bottomRows; y++){
				for(let x = 0; x < cols; x++){
					let $card = $cards[count];
					if($card){
						let posX = gridStartX + x * (cardW + cardM);
						let posY = startBottom + cardM + y * (cardH + cardM);
						$card.style.transform = `translate3d(${posX}px, ${posY}px, 0)`;
					}
					count++;
				}
			}
	
		}else{
			// PC: 既存ロジック
			let count = 0;
			let posYTotal = 0;
			let xLen = [6, 4, 6];
	
			for(let y = 0; y < 3; y++){
				for(let x = 0; x < xLen[y]; x++){
					let $card = $cards[count];
					let posX, posY;
					if($card){
						if(y === 0){
							let n = xLen[y] - x - 3;
							posX = centerX - ((cardW + cardM) * n) + cardM / 2;
							posY = centerY - startBlockH / 2 - cardM - cardH;
							if(x === xLen[y] - 1){
								posYTotal += posY + cardH + cardM;
							}
						}else if(y === 2){
							let n = xLen[y] - x - 3;
							posX = centerX - ((cardW + cardM) * n) + cardM / 2;
							posY = posYTotal;
						}else if(y === 1){
							let n = xLen[y] - x - 2;
							if(x < 2){
								posX = centerX - startBlockW / 2 - (cardW + cardM) * (x + 1);
							}else{
								posX = centerX + startBlockW / 2 + cardM + (cardW + cardM) * (x - 2);
							}
							posY = posYTotal;
							if(x === xLen[y] - 1){
								posYTotal += cardH + cardM;
							}
						}
						$card.style.transform = `translate3d(${posX}px, ${posY}px, 0)`;
					}
					count++;
				}
			}
			let $startBlock = document.querySelector(".c-start");
			let $startBlockTtl = document.querySelector(".c-start .ttl");
			let $startBlockBtn = document.querySelector(".c-start .c-start_btns");
			$startBlock.style.height = cardH + "px";
			$startBlockTtl.style.height = cardH - $startBlockBtn.clientHeight + "px";
		}
	}
}
let getPx = (vw) =>{
	let $main = document.querySelector("main");
	if( window.innerWidth <= 768 ){
		return parseFloat(vw) * (window.innerWidth / 100);
	}else{
		if( $main.classList.contains("v") ){
			return parseFloat(vw.replace("vh", "")) * (window.innerHeight / 100);
		}else if( $main.classList.contains("h") ){
			return parseFloat(vw.replace("vw", "")) * (window.innerWidth / 100);
		}
	}
}